<template>
  <div class="mdl-grid">

    <div v-if='~isConnectedtoBC()'>
      Not connected to the Ethereum blockchain. Metamask is required.
      <a href='https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn' target="_blank">Install Metamask extension for Google Chrome</a>
    </div>

    <div class="mdl-card mdl-cell mdl-cell--6-col mdl-shadow--2dp" v-if='isConnectedtoBC()'>

          <h3>Register a new charge</h3>

          <button @click="addCharge" class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored">
          Add a new charge
          </button>

          <br>

          <form>
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
              <select class="mdl-textfield__input" id="charger_id" v-model="charger_id">
                <option></option>
                <option value="100">100 (Location A)</option>
                <option value="200">200 (Location B)</option>
                <option value="300">300 (Location C)</option>
              </select>
              <label class="mdl-textfield__label" for="charger_id">Charger id</label>
            </div>
          </form>

          <form>
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
              <select class="mdl-textfield__input" id="start_time" v-model="start_time">
                <option></option>
                <option value="20180601">2018-06-01</option>
                <option value="20180602">2018-06-02</option>
                <option value="20180603">2018-06-03</option>
                <option value="20180604">2018-06-04</option>
                <option value="20180605">2018-06-05</option>
                <option value="20180606">2018-06-06</option>
              </select>
              <label class="mdl-textfield__label" for="start_time">Start time</label>
            </div>
          </form>

          <form>
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
              <select class="mdl-textfield__input" id="duration" v-model="duration">
                <option></option>
                <option value="4">4 hours</option>
                <option value="6">6 hours</option>
                <option value="8">8 hours</option>
              </select>
              <label class="mdl-textfield__label" for="duration">Duration</label>
            </div>
          </form>

          <form>
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
              <select class="mdl-textfield__input" id="mode" v-model="mode">
                <option></option>
                <option value="0">Normal</option>
                <option value="1">Flexible</option>
              </select>
              <label class="mdl-textfield__label" for="mode">Charging mode</label>
            </div>
          </form>

          Your bonus for this charge is ___ units<br><br>

    </div>

    <div class="mdl-card mdl-cell mdl-cell--6-col mdl-shadow--2dp" v-if='isConnectedtoBC()'>

          <h3>Account info</h3>

          <button @click="getBonus" class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored">
          Update account info
          </button>

          <br>

          <div style='padding: 20px'>
            • Connected: {{ testConnection() }} <br><br>
            • Provider name: {{ providerName() }} <br><br>
            • Account: {{ account }} <br><br>
            • Balance: __ ETH <br><br>
            • Bonus: {{ bonus }} unit(s)
          </div>

 
    </div>  

    <div class="mdl-card mdl-cell mdl-cell--12-col mdl-shadow--2dp" v-if='isConnectedtoBC()'>

           <h3>Previous charges</h3>

          <button @click="getChargesInfo" class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored">
          See my previous charges
          </button>

          <div v-if="all_charges && all_charges.length">

             <table class="mdl-data-table mdl-js-data-table" style='width: 100%'>
              <thead>
                <tr>
                  <th v-for="(col, index) in table.columns" :key="index"
                      class="mdl-data-table__cell--non-numeric">
                      {{ col }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(charge, index) in all_charges" :key="index">
                  <td class="mdl-data-table__cell--non-numeric">{{ charge }} </td>
                  <td class="mdl-data-table__cell--non-numeric">{{ all_charges_info[index][1] }}</td>
                  <td class="mdl-data-table__cell--non-numeric">{{ all_charges_info[index][2] }}</th>
                  <td class="mdl-data-table__cell--non-numeric">{{ all_charges_info[index][3] }}</td>
                  <td class="mdl-data-table__cell--non-numeric">{{ all_charges_info[index][4] }}</td>
                  <td class="mdl-data-table__cell--non-numeric">{{ all_charges_info[index][5] }}</td>
                </tr>
              </tbody>
            </table>

          </div> 

    </div>

  </div>

</template>

<script>
import ChargingLedger from '../utils/contractInstance.js'
import web3Instance from '../utils/web3Instance'

export default {

  name: 'CustomerPage',

  data () {
    return {

      bonus: 0,

      all_charges: [],
      all_charges_info: [],

      charger_id: '',
      start_time: '',
      duration: '',
      mode: '',

      table: {'columns': ['Charge id', 'Charger id', 'Start date', 'Duration (h)', 'Mode', 'Bonus (Units)']}
    }
  },

  mounted () {
    if (this.isConnectedtoBC()) {
      ChargingLedger.init()
    }
  },

  methods: {

    providerName () {
      return web3Instance.currentProvider.constructor.name == 'MetamaskInpageProvider' ? 'metamask' : 'http'
    },

    isConnectedtoBC () {
      try {
        var accounts = web3Instance.eth.accounts[0]
        } catch (err) {
        console.log(err)
      }
      return typeof accounts !== 'undefined' ? true : false
    },

    addCharge () {
      if (this.isConnectedtoBC()) {
        var charger_id = Number(this.charger_id)
        var start = Number(this.start_time)
        var duration = Number(this.duration)
        var mode = Number(this.mode)

        if (charger_id && start && duration && mode) {
          ChargingLedger.addNewCharge(charger_id, start, duration, mode).then(console.log)
        }
      }
    },

    getCharges () {
      if (this.isConnectedtoBC()) {
        ChargingLedger.getChargesList().then(res => {this.all_charges = res})
        var charge_id = "0xec1d06b169784d11a767f39863498468733bdf49ab0f23c6a99b6ee5513f35f3"
        ChargingLedger.getChargeInfo(charge_id)
      }
    },

    getChargesInfo () {
      if (this.isConnectedtoBC()) {
        ChargingLedger.getChargesList().then(
            res => {this.all_charges = res}
          ).then( res => {
              var i;
              for (i = 0; i < this.all_charges.length; i++) { 
                  ChargingLedger.getChargeInfo(this.all_charges[i]).then(res => {
                    this.all_charges_info.push(res)})
              };
          })
      }
    },

    getBonus () {
      if (this.isConnectedtoBC()) {
        var user_id = window.web3.eth.accounts[0]
        ChargingLedger.getUserBalance(user_id).then(res => {this.bonus = Number(res)})
      }
    },

  },

  computed: {

      account () {
        return this.isConnectedtoBC() ? web3Instance.eth.accounts[0] : 'NaN'
      },

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/customer-page.vue